import { apiFetch } from "@/lib/api";

export interface CbpMonthlyStatementDocument {
  cbp_invoice_id: string;
  cbp_vendor_invoice_number: string;
  amount: string;
  currency: string;
  cbp_status: string;
  cbp_status_label: string;
  tsh_workflow_status: string | null;
  tsh_workflow_status_label: string | null;
  shipper_invoice_id: string;
  shipper_vendor_invoice_number: string;
  shipper_status: string;
  shipper_status_label: string;
  gipi_id: string | null;
  gipi_number: string | null;
  gipi_status: string | null;
  release_on: string;
}

export interface CbpMonthlyStatementMonth {
  statement_month: string;
  due_on: string;
  totals: Array<{ currency: string; amount: string }>;
  documents: CbpMonthlyStatementDocument[];
}

export function fetchCbpMonthlyStatements(): Promise<{ months: CbpMonthlyStatementMonth[] }> {
  return apiFetch("/api/accounting/ap/cbp-monthly-statements");
}
